import { PermissionEntityType, PermissionModel, PermissionType } from '@models';

const getPermission = (
  permissions: PermissionModel[],
  permissionType: PermissionType,
  entityType: PermissionEntityType
): PermissionModel | undefined => {
  if (!permissions) {
    return undefined;
  }

  return permissions.find(
    (permission) =>
      permission.permissionType === permissionType && permission.entityType === entityType
  );
};

export { getPermission };
